import React from 'react';

const NotFound = () => {
    return (
        <div>
            <h1 style={{textAlign: 'center',color: 'white', marginTop:'20px'}}>Sorry Not found</h1>
        </div>
    );
};

export default NotFound;